import React from 'react';
import styled from 'styled-components';
import Alert from 'react-bootstrap/Alert';
import {fontSize, StyledBootstrapAlert, tabletWidth} from '../../mixins';
import {ArrowInCircle} from '../../UI/Icons';
import AlertClose from '../../UI/AlertClose';

const StyledNote = styled(Alert)`
 ${StyledBootstrapAlert};
 z-index: 1000;
 padding: 6px 40px;
 
 @media screen and (max-width: ${tabletWidth}) {
  width: 58%;
  
  p {
   ${fontSize(12)};
   padding-right: 7px;
  }
 }
 
 div {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  height: 100%;
 }
`

const StyledOpenBtn = styled.button`
 position: absolute;
 background-color: transparent;
 border: none;
 width: 30px;
 height: 30px;
 padding: 4px;
 top: 50%;
 left: 0;
 margin-top: -15px;
`


const DownloadCrouton = ({show, onCloseHandler, onClickHandler}) => (
    <StyledNote show={show} onClose={onCloseHandler}>
        <AlertClose onClick={onCloseHandler}/>
        <StyledOpenBtn onClick={onClickHandler} id='continue-button'>{ArrowInCircle}</StyledOpenBtn>
        <div onClick={onClickHandler} id='continue-button'>
            <p>Get more with Geozilla on your phone!</p>
        </div>
    </StyledNote>
);

export default DownloadCrouton;